module.exports = __webpack_public_path__ + "static/media/62.700cf370.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/62.jpg
// module id = 622
// module chunks = 0